import axios from './baseURL' // 引入刚刚创建的域名文件
const base = '/api';// 解决跨域问题
const api = {
    siteMsg(params) {return axios.get(`${base}/fragment/siteMsg`,{params: params})},  //站点信息
    index(params) {return axios.get(`${base}/index/index`,{params: params})},  //首页第一屏
    secondHome(params) {return axios.get(`${base}/index/secondHome`,{params: params})},  //首页第二屏
    aboutUs(params) {return axios.get(`${base}/about/aboutUs`,{params: params})},  //公司简介
    teamImageList(params) {return axios.get(`${base}/about/teamImageList`,{params: params})},  //团队照片
    transportationCaseList(params) {return axios.get(`${base}/about/transportationCaseList`,{params: params})},  //运输案例
    jobList(params) {return axios.get(`${base}/about/jobList`,{params: params})},  //人才招募
    businessList(params) {return axios.get(`${base}/fragment/businessList`,{params: params})},  //业务范围列表
    businessDetail(params) {return axios.get(`${base}/fragment/businessDetail`,{params: params})},  //业务范围详情
    solutionList(params) {return axios.get(`${base}/fragment/solutionList`,{params: params})},  //产品方案列表
    solutionDetail(params) {return axios.get(`${base}/fragment/solutionDetail`,{params: params})},  //产品方案详情
    companyList(params) {return axios.get(`${base}/contact/companyList`,{params: params})},  //联系我们-公司列表
    submitMessage(params) {return axios.post(`${base}/contact/submitMessage`,params)},  //留言信息提交
    submitQuotation(params) {return axios.post(`${base}/contact/submitQuotation`,params)},  //首页获取报价
    newsList(params) {return axios.get(`${base}/news/newsList`,{params: params})},  //首页-资讯列表
    newsDetail(params) {return axios.get(`${base}/news/newsDetail`,{params: params})},  //首页-资讯详情
    getVerifyCode(params) {return axios.post(`${base}/fragment/smsSend`,params)},  //获取验证码
    devHistoryList(params) {return axios.get(`${base}/about/devHistoryList`,{params: params})},  //首页-发展历程
    videoList(params) {return axios.get(`${base}/about/videoList`,{params: params})},  //首页-视频展示

};
export default api




// WEBPACK FOOTER //
// ./src/axios/api.js